<template>
  <a-avatar
    v-if="src"
    :src="src"
    :size="sizeResponsive"
    class="avatar"
    @click="$emit('onClick')"
  />
  <DefaultIconLetter
    v-else
    class="avatar"
    :names="names"
    :size="sizeResponsive"
    @click="$emit('onClick')"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultIconLetter from '@/app/shared/components/avatars/DefaultIconLetter.vue'

export default {
  name: 'AvatarUser',
  props: {
    src: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: Number,
      default: 24,
      required: false,
    },
    xs: {
      type: Number,
      default: null,
      required: false,
    },
    sm: {
      type: Number,
      default: null,
      required: false,
    },
    md: {
      type: Number,
      default: null,
      required: false,
    },
    lg: {
      type: Number,
      default: null,
      required: false,
    },
    xl: {
      type: Number,
      default: null,
      required: false,
    },
    names: {
      type: String,
      required: false,
    },
  },
  components: {
    DefaultIconLetter,
  },
  computed: {
    ...mapGetters(['active_breakpoint']),

    sizeResponsive() {
      const breakpoint = this.active_breakpoint.breakpoint
      const sizeResponsive = this[breakpoint]
      if (sizeResponsive) return sizeResponsive
      else return this.size
    },
  },
}
</script>

<style scoped></style>
